import {
  ADD_LOCAL_COLLECTION,
  DELETE_LOCAL_COLLECTION
} from '@/store/mutation-types'
import { userCollection, cancelCollection } from '@/api/collection'
import { mapGetters } from 'vuex'
// import { sendWSPush } from '@/utils/webSocket'

export default {
  computed: {
    ...mapGetters(['isSignIn']),
    collectCoinListLocal() {
      return this.$store.state.market.collectCoinListLocal
    },
    collectCoinListOrigin() {
      return this.$store.state.market.collectCoinListOrigin
    }
  },
  methods: {
    // 远程收藏（用户收藏、取消收藏）
    async handleOriginCollect(marketId, isCollect) {
      if (isCollect) {
        await this.callCancelCollect(marketId)
      } else {
        await this.callUserCollect(marketId)
      }
      this.$store.dispatch('market/setCollectionCoin')
    },
    // 本地收藏（用户收藏、取消收藏）
    handleNativeCollect(coin) {
      const idx = this.collectCoinListLocal.findIndex(
        (item) => item.marketId === coin.marketId
      )

      if (idx !== -1) {
        this.$store.commit(`market/${DELETE_LOCAL_COLLECTION}`, idx)
      } else {
        this.$store.commit(`market/${ADD_LOCAL_COLLECTION}`, coin)
      }
    },
    // 调用用户收藏
    async callUserCollect(marketId) {
      console.log({ marketId })
      await userCollection({ marketId })
      this.$notify.success({
        title: this.$t('操作成功'),
        duration: 3000,
        offset: 100
      })
    },
    // 调用取消收藏
    async callCancelCollect(marketId) {
      await cancelCollection({ marketId })
      this.$notify.success({
        title: this.$t('操作成功'),
        duration: 3000,
        offset: 100
      })
    },
    // 处理远程币种是否收藏（返回布尔值）
    dealCoinCollect(symbol) {
      for (const item of this.collectCoinListOrigin) {
        if (item.symbol === symbol) {
          return true
        }
      }
    },
    // 对比处理远程收藏币种的列表（返回数组）
    dealOriginCoinCollectList(coin) {
      let collectionCoinList = []
      for (const item of allCoinList) {
        for (const part of this.collectCoinListOrigin) {
          if (item.symbol === part.symbol) {
            collectionCoinList.push(item)
          }
        }
      }
      return collectionCoinList
    },
    // 对比处理本地收藏币种的列表（返回数组）
    dealLocalCoinCollectList(allCoinList) {
      let collectionCoinList = []
      for (let key in this.collectCoinListLocal) {
        for (const item of allCoinList) {
          if (key === item.symbol) {
            collectionCoinList.push(item)
          }
        }
      }
      return collectionCoinList
    }
  }
}
